// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","AppContent":"App_AppContent__3Ir10","communityDetailsWrapper":"App_communityDetailsWrapper__3fFJV"};